/**
 * Centralized translations for Data Import functionality
 * Contains all labels used across data import components
 */

export const ImportLabels = {
    it: {
        // Data Import labels
        selectDataType: 'Seleziona Tipologia Dati',
        uploadExcelFile: 'Carica File Excel',
        dataPreview: 'Anteprima Dati',
        importHealthData: 'Import Dati Sanitari',
        importValidateDescription: 'Importa e valida dati da file Excel per diverse tipologie di dati sanitari',
        
        // Import types
        antibioticConsumption: 'Consumo Antibiotici',
        medicalDeviceConsumption: 'Dispositivi Medici',
        hydroalcoholicGelConsumption: 'Gel Idroalcolico',
        hospitalizationEvents: 'Eventi Ospedalizzazione',
        
        // Hospitalization profiles
        detectedProfile: 'Profilo Rilevato',
        profileAslRoma1Description: 'Il backend utilizzerà il mapping colonne specifico per ASL Roma 1',
        profileStandardDescription: 'Il backend utilizzerà il mapping colonne standard',
        hospitalizationMultiProfileInfo: 'Il sistema rileva automaticamente il formato del file. Colonne mostrate sono per riferimento (profilo STANDARD).',
        
        // File upload
        dragDropFile: 'Trascina qui il file Excel o clicca per selezionare',
        supportedFormats: 'Formati supportati: .xlsx, .xls',
        selectFile: 'Seleziona File',
        removeFile: 'Rimuovi File',
        fileSize: 'Dimensione',
        
        // Validation and analysis
        startPreAnalysis: 'Avvia Pre-Analisi',
        analysisInProgress: 'Analisi in corso...',
        processingInProgress: 'Elaborazione in corso...',
        importInProgress: 'Importazione...',
        
        // Columns and data
        requiredFields: 'campi obbligatori',
        expectedColumns: 'Colonne attese nel file Excel per',
        excelColumnInfo: 'Il file Excel deve contenere le colonne con nomi italiani come mostrato qui sotto.',
        requiredField: 'Campi obbligatori',
        previewColumns: 'Anteprima colonne Excel',
        previewDescription: 'Vengono mostrati i nomi originali delle colonne come appaiono nel file Excel.',
        totalRows: 'Totale righe nel file',
        detectedColumns: 'Colonne rilevate',
        firstRows: 'Prime 10 righe',
        
        // Results
        importableData: 'Dati Importabili',
        importableRows: 'Righe Importabili',
        dataWithErrors: 'Dati con Errori',
        rowsWithErrors: 'Righe con Errori',
        cleanDataAvailable: 'record puliti disponibili per l\'importazione',
        noCleanData: 'Nessun dato pulito disponibile per l\'importazione.',
        noErrorsDetected: 'Nessun errore rilevato nei dati.',
        importCleanRecords: 'Importa {count} Record Puliti',
        row: 'Riga',
        errorCode: 'Codice',
        
        // Messages and alerts
        ok: 'OK',
        error: 'Errore',
        attention: 'Attenzione',
        selectTypeFirst: 'Seleziona prima il tipo di importazione',
        invalidFileFormat: 'Formato file non valido',
        selectExcelFile: 'Seleziona un file Excel (.xlsx o .xls)',
        missingColumns: 'Colonne Mancanti o Errate',
        missingColumnsDescription: 'Il file Excel non contiene tutte le colonne richieste:',
        missingColumnsLabel: 'Colonne mancanti:',
        foundColumnsLabel: 'Colonne trovate nel file:',
        requiredColumnsLabel: 'Colonne richieste:',
        columnNamesInfo: 'Assicurati che il file Excel contenga le colonne con i nomi italiani esatti come mostrato nella sezione "Colonne attese".',
        validationError: 'Errore di Validazione',
        validationRequestFailed: 'Impossibile validare il file. Riprova.',
        emptyFile: 'File Vuoto',
        emptyFileDescription: 'Il file Excel non contiene dati o è vuoto',
        proceedAnyway: 'Procedi Comunque',
        cancel: 'Annulla',
        emptyExcelFile: 'Il file Excel è vuoto',
        excelParsingError: 'Errore nel parsing del file Excel',
        fileReadError: 'Errore nella lettura del file',
        
        // Pre-analysis errors
        preAnalysisError: 'Errore Pre-Analisi',
        preAnalysisErrorDescription: 'Errore durante la pre-analisi dei dati:',
        unknownPreAnalysisError: 'Errore sconosciuto durante la pre-analisi',
        verifyColumnsData: 'Verifica che il file contenga le colonne corrette e che i dati siano nel formato atteso.',
        connectionError: 'Errore di Connessione',
        connectionErrorDescription: 'Errore di connessione durante la pre-analisi:',
        serverConnectionError: 'Impossibile contattare il server',
        checkConnectionRetry: 'Verifica la connessione internet e riprova. Se il problema persiste, contatta l\'amministratore di sistema.',
        
        // Import confirmation and results
        confirmImport: 'Conferma Importazione',
        confirmImportMessage: 'Stai per importare {count} record. Continuare?',
        importData: 'Importa',
        importCompleted: 'Importazione Completata',
        recordsImportedSuccessfully: '{count} record importati con successo',
        importError: 'Errore Importazione',
        finalImportError: 'Errore durante l\'importazione finale:',
        unknownImportError: 'Errore sconosciuto durante l\'importazione',
        dataNotSaved: 'I dati non sono stati salvati. Verifica i messaggi di errore e riprova.',
        importConnectionError: 'Errore di connessione durante l\'importazione:',
        importMayNotBeComplete: 'L\'importazione potrebbe non essere stata completata. Verifica la connessione e riprova.',
        selected: 'Selezionato',
        
        // Progress tracking labels
        progress: 'Progresso',
        rows: 'righe',
        currentStatus: 'Stato Corrente',
        processing: 'Elaborazione in corso',
        analysisProgress: 'Progresso Analisi',
        importProgress: 'Progresso Importazione',
        initializingAnalysis: 'Inizializzazione analisi...',
        analysisCompleted: 'Analisi completata',
        realtimeWarnings: 'Avvisi in Tempo Reale',
        andMore: '... e altri {count}',
        progressTrackingError: 'Errore Tracciamento Progresso',
        progressTrackingErrorDescription: 'Si è verificato un errore nel tracciamento del progresso. L\'importazione continuerà in background.',
        progressNotAvailable: 'Tracciamento Progresso Non Disponibile',
        progressNotAvailableDescription: 'Il tracciamento del progresso in tempo reale non è disponibile. L\'importazione continuerà in background.',
        progressTrackingUnavailable: 'Tracciamento progresso non disponibile - importazione in corso in background...',
        
        // Task completion status labels
        taskCompleted: 'Attività completata',
        processingCompleted: 'Elaborazione completata con successo',
        analysisFailed: 'Analisi fallita',
        taskFailed: 'Attività fallita',
        loading: 'Caricamento...',
        
        // Download labels
        downloadErrorReport: 'Scarica Report Errori',
        downloadImportableData: 'Scarica Dati Importabili',
        downloadCompleted: 'Download Completato',
        errorDataDownloaded: 'I dati con errori sono stati scaricati come {filename}',
        cleanDataDownloaded: 'I dati importabili sono stati scaricati come {filename}',
        downloadError: 'Errore Download',
        errorGeneratingFile: 'Si è verificato un errore durante la generazione del file Excel. Riprova.',
        noDataToDownload: 'Nessun Dato da Scaricare',
        noErrorDataAvailable: 'Non ci sono record con errori da scaricare.',
        noCleanDataAvailable: 'Non ci sono dati importabili da scaricare.',
        rowNumber: 'Riga',
        errorDescription: 'Descrizione Errore',
        errors: 'Errori',
        
        // Pagination labels
        showing: 'Mostrando',
        of: 'di',
        records: 'record',
        
        // Statistics Panel labels
        importStatistics: 'Statistiche Importazione',
        excelFile: 'File Excel',
        backendProcessing: 'Elaborazione Backend',
        rowTracking: 'Tracciamento Righe',
        sentToBackend: 'Inviate al Backend',
        received: 'Ricevute',
        emptyRowsFiltered: 'Righe Vuote Filtrate',
        cleanRows: 'Righe Valide',
        dirtyRows: 'Righe con Errori',
        totalProcessed: 'Totale Elaborate',
        missingRows: 'Righe Mancanti',
        allRowsAccounted: '0 Mancanti',
        
        // Missing rows warning
        missingRowsWarning: 'Attenzione: Righe Mancanti',
        missingRowsDescription: 'Alcune righe non sono state elaborate dal backend. Controlla i log della console per dettagli.',
        possibleReasons: 'Possibili cause',
        missingReason1: 'Righe duplicate filtrate dal backend',
        missingReason2: 'Righe con dati non validi scartate senza warning',
        missingReason3: 'Filtri di business logic applicati dal backend',
        
        // Success messages
        allRowsAccountedSuccess: 'Tutte le righe sono state elaborate correttamente!',
        rowsReadyForImport: 'righe pronte per l\'importazione',
        rowsWithErrors: 'righe con errori',
        
        // Hospitalization conversion labels
        hospitalizationConversionInfo: 'Trasformazione Eventi → Periodi di Degenza',
        hospitalizationConversionDescription: 'Gli eventi di degenza (ADM, TNF, DSC) vengono trasformati in periodi di degenza.',
        inputEvents: 'Eventi Input',
        validatedEvents: 'Eventi Validati',
        rejectedEvents: 'Eventi Rifiutati',
        outputStays: 'Degenze Output',
        staysGenerated: 'Degenze Generate',
        conversionRatio: 'Rapporto Conversione',
    },
    
    en: {
        // Data Import labels
        selectDataType: 'Select Data Type',
        uploadExcelFile: 'Upload Excel File',
        dataPreview: 'Data Preview',
        importHealthData: 'Import Health Data',
        importValidateDescription: 'Import and validate data from Excel files for various health data types',
        
        // Import types
        antibioticConsumption: 'Antibiotic Consumption',
        medicalDeviceConsumption: 'Medical Device Consumption',
        hydroalcoholicGelConsumption: 'Hydroalcoholic Gel Consumption',
        hospitalizationEvents: 'Hospitalization Events',
        
        // Hospitalization profiles
        detectedProfile: 'Detected Profile',
        profileAslRoma1Description: 'The backend will use ASL Roma 1 specific column mapping',
        profileStandardDescription: 'The backend will use standard column mapping',
        hospitalizationMultiProfileInfo: 'The system automatically detects the file format. Columns shown are for reference (STANDARD profile).',
        
        // File upload
        dragDropFile: 'Drag Excel file here or click to select',
        supportedFormats: 'Supported formats: .xlsx, .xls',
        selectFile: 'Select File',
        removeFile: 'Remove File',
        fileSize: 'Size',
        
        // Validation and analysis
        startPreAnalysis: 'Start Pre-Analysis',
        analysisInProgress: 'Analysis in progress...',
        processingInProgress: 'Processing in progress...',
        importInProgress: 'Importing...',
        
        // Columns and data
        requiredFields: 'required fields',
        expectedColumns: 'Expected columns in Excel file for',
        excelColumnInfo: 'Excel file must contain columns with Italian names as shown below.',
        requiredField: 'Required fields',
        previewColumns: 'Excel columns preview',
        previewDescription: 'Original column names as they appear in the Excel file are shown.',
        totalRows: 'Total rows in file',
        detectedColumns: 'Detected columns',
        firstRows: 'First 10 rows',
        
        // Results
        importableData: 'Importable Data',
        importableRows: 'Importable Rows',
        dataWithErrors: 'Data with Errors',
        rowsWithErrors: 'Rows with Errors',
        cleanDataAvailable: 'clean records available for import',
        noCleanData: 'No clean data available for import.',
        noErrorsDetected: 'No errors detected in data.',
        importCleanRecords: 'Import {count} Clean Records',
        row: 'Row',
        errorCode: 'Code',
        
        // Messages and alerts
        ok: 'OK',
        error: 'Error',
        attention: 'Warning',
        selectTypeFirst: 'Select import type first',
        invalidFileFormat: 'Invalid file format',
        selectExcelFile: 'Select an Excel file (.xlsx or .xls)',
        missingColumns: 'Missing or Incorrect Columns',
        missingColumnsDescription: 'Excel file does not contain all required columns:',
        missingColumnsLabel: 'Missing columns:',
        foundColumnsLabel: 'Columns found in file:',
        requiredColumnsLabel: 'Required columns:',
        columnNamesInfo: 'Make sure the Excel file contains columns with exact Italian names as shown in the "Expected columns" section.',
        validationError: 'Validation Error',
        validationRequestFailed: 'Unable to validate file. Please try again.',
        emptyFile: 'Empty File',
        emptyFileDescription: 'The Excel file contains no data or is empty',
        proceedAnyway: 'Proceed Anyway',
        cancel: 'Cancel',
        emptyExcelFile: 'Excel file is empty',
        excelParsingError: 'Error parsing Excel file',
        fileReadError: 'Error reading file',
        
        // Pre-analysis errors
        preAnalysisError: 'Pre-Analysis Error',
        preAnalysisErrorDescription: 'Error during data pre-analysis:',
        unknownPreAnalysisError: 'Unknown error during pre-analysis',
        verifyColumnsData: 'Verify that the file contains correct columns and data is in expected format.',
        connectionError: 'Connection Error',
        connectionErrorDescription: 'Connection error during pre-analysis:',
        serverConnectionError: 'Unable to contact server',
        checkConnectionRetry: 'Check internet connection and try again. If problem persists, contact system administrator.',
        
        // Import confirmation and results
        confirmImport: 'Confirm Import',
        confirmImportMessage: 'You are about to import {count} records. Continue?',
        importData: 'Import',
        importCompleted: 'Import Completed',
        recordsImportedSuccessfully: '{count} records imported successfully',
        importError: 'Import Error',
        finalImportError: 'Error during final import:',
        unknownImportError: 'Unknown error during import',
        dataNotSaved: 'Data was not saved. Check error messages and try again.',
        importConnectionError: 'Connection error during import:',
        importMayNotBeComplete: 'Import may not have been completed. Check connection and try again.',
        selected: 'Selected',
        
        // Progress tracking labels
        progress: 'Progress',
        rows: 'rows',
        currentStatus: 'Current Status',
        processing: 'Processing',
        analysisProgress: 'Analysis Progress',
        importProgress: 'Import Progress',
        initializingAnalysis: 'Initializing analysis...',
        analysisCompleted: 'Analysis completed',
        realtimeWarnings: 'Real-time Warnings',
        andMore: '... and {count} more',
        progressTrackingError: 'Progress Tracking Error',
        progressTrackingErrorDescription: 'There was an error with progress tracking. The import will continue in the background.',
        progressNotAvailable: 'Progress Tracking Not Available',
        progressNotAvailableDescription: 'Real-time progress tracking is not available. The import will continue in the background.',
        progressTrackingUnavailable: 'Progress tracking unavailable - import continuing in background...',
        
        // Task completion status labels
        taskCompleted: 'Task completed',
        processingCompleted: 'Processing completed successfully',
        analysisFailed: 'Analysis failed',
        taskFailed: 'Task failed',
        loading: 'Loading...',
        
        // Download labels
        downloadErrorReport: 'Download Error Report',
        downloadImportableData: 'Download Importable Data',
        downloadCompleted: 'Download Completed',
        errorDataDownloaded: 'Error data has been downloaded as {filename}',
        cleanDataDownloaded: 'Importable data has been downloaded as {filename}',
        downloadError: 'Download Error',
        errorGeneratingFile: 'There was an error generating the Excel file. Please try again.',
        noDataToDownload: 'No Data to Download',
        noErrorDataAvailable: 'There are no error records to download.',
        noCleanDataAvailable: 'There are no importable records to download.',
        rowNumber: 'Row Number',
        errorDescription: 'Error Description',
        errors: 'Errors',
        
        // Pagination labels
        showing: 'Showing',
        of: 'of',
        records: 'records',
        
        // Statistics Panel labels
        importStatistics: 'Import Statistics',
        excelFile: 'Excel File',
        backendProcessing: 'Backend Processing',
        rowTracking: 'Row Tracking',
        sentToBackend: 'Sent to Backend',
        received: 'Received',
        emptyRowsFiltered: 'Empty Rows Filtered',
        cleanRows: 'Valid Rows',
        dirtyRows: 'Rows with Errors',
        totalProcessed: 'Total Processed',
        missingRows: 'Missing Rows',
        allRowsAccounted: '0 Missing',
        
        // Missing rows warning
        missingRowsWarning: 'Warning: Missing Rows',
        missingRowsDescription: 'Some rows were not processed by the backend. Check console logs for details.',
        possibleReasons: 'Possible reasons',
        missingReason1: 'Duplicate rows filtered by backend',
        missingReason2: 'Invalid data rows discarded without warning',
        missingReason3: 'Business logic filters applied by backend',
        
        // Success messages
        allRowsAccountedSuccess: 'All rows have been processed correctly!',
        rowsReadyForImport: 'rows ready for import',
        rowsWithErrors: 'rows with errors',
        
        // Hospitalization conversion labels
        hospitalizationConversionInfo: 'Events → Stay Periods Transformation',
        hospitalizationConversionDescription: 'Hospitalization events (ADM, TNF, DSC) are transformed into stay periods.',
        inputEvents: 'Input Events',
        validatedEvents: 'Validated Events',
        rejectedEvents: 'Rejected Events',
        outputStays: 'Output Stays',
        staysGenerated: 'Stays Generated',
        conversionRatio: 'Conversion Ratio',
    }
};
